import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Asset, AssetLien} from '../../shared/domain/item';
import {AssetPackageDto} from '../../shared/domain/asset-package';
import {AssetLienComponent} from '../asset-lien/asset-lien.component';
import {MatDialog} from '@angular/material/dialog';
import {AssetLienEditComponent} from '../asset-lien/asset-lien-edit/asset-lien-edit.component';
import {DialogService, UserSessionService} from '@rbaip/ui-component';
import {AssetLienService} from '../asset-lien/shared/asset-lien-service';
import {Subscription} from 'rxjs';
import {ItemSummaryAssetControlGroupService} from '../../shared/asset-package/item-summary-asset-control-group.service';

@Component({
  selector: 'lib-item-summary-item-lien-info',
  templateUrl: './item-lien-info.component.html',
  styleUrls: ['./item-lien-info.component.scss']
})
export class ItemLienInfoComponent implements OnInit, OnDestroy {
  @Input() asset: Asset;
  @Input() assetControlGroup: AssetPackageDto;
  @Input() showLienInfo: boolean;
  @Input() isLienEditable: boolean;
  @Input() editAssetFromPricing: boolean;

  isTm = false;
  private currentUserChangedSubscription: Subscription;
  private packageTeamMemberSubscription: Subscription;

  constructor(private dialog: MatDialog,
              private dialogService: DialogService,
              private assetLienService: AssetLienService,
              private userSessionService: UserSessionService,
              private assetControlGroupService: ItemSummaryAssetControlGroupService) {
  }

  ngOnInit(): void {
    this.subscribeUserChanged();
    if (this.userSessionService.getCurrentUser()) {
      this.isCurrentUserIsPackageTeamMember(this.userSessionService.getCurrentUser().userId);
    }
  }

  ngOnDestroy(): void {
    if (this.currentUserChangedSubscription) {
      this.currentUserChangedSubscription.unsubscribe();
    }
    if (this.packageTeamMemberSubscription) {
      this.packageTeamMemberSubscription.unsubscribe();
    }
  }

  private subscribeUserChanged() {
    this.currentUserChangedSubscription = this.userSessionService.userChanged
      .subscribe((siteUser) => {
        if (siteUser) {
          this.isCurrentUserIsPackageTeamMember(siteUser.userId);
        }
      });
  }

  private isCurrentUserIsPackageTeamMember(userId: number) {
    if (this.asset.assetControlGroupId > 0) {
      this.packageTeamMemberSubscription = this.assetControlGroupService.isPackageTeamMember(this.asset.assetControlGroupId, userId)
        .subscribe(userRoleType => {
          if (userRoleType) {
            this.isTm = userRoleType.tm;
          }
        });
    }
  }

  showAssetLienForm() {
    this.dialog.open(AssetLienComponent, {
      panelClass: 'mat-panel--full-height',
      data: {
        asset: this.asset,
        editAssetFromPricing: this.editAssetFromPricing
      }
    }).afterClosed().subscribe(newlyCreatedLienHolder => {
      console.log('Lien Holder Created ', newlyCreatedLienHolder);
    });
  }

  public createLienHolder() {
    const lienFields = new AssetLien();
    if (this.asset.assetLiens == null) {
      this.asset.assetLiens = [];
    }
    lienFields.index = this.asset.assetLiens.length + 1;
    lienFields.assetId = this.asset.assetId;
    lienFields.acgId = this.asset.assetControlGroupId;
    lienFields.lienTypeId = 1;

    this.dialog.open(AssetLienEditComponent, {
      panelClass: 'mat-panel--full-height',
      autoFocus: false,
      data: {
        editing: false,
        item: lienFields
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        const [assetLien, isDeleted] = response;
        if (!isDeleted) {
          this.asset.assetLiens = assetLien;
        }
      }
    });
  }

  public editLienHolder(event) {
    event.acgId = this.asset.assetControlGroupId;

    this.dialog.open(AssetLienEditComponent, {
      panelClass: 'mat-panel--full-height',
      autoFocus: false,
      data: {
        editing: true,
        item: event
      }
    }).afterClosed().subscribe(response => {
      if (response) {
        const [assetLien, isDeleted] = response;
        if (isDeleted) {
          this.asset.assetLiens = this.asset.assetLiens.filter(lien => lien.lienId !== assetLien.lienId);
        } else {
          this.asset.assetLiens = assetLien;
        }
      }
    });
  }

  updateLienFlag() {
    const lienFlag = this.asset.lienYn ? 'Y' : 'N';
    this.dialogService.showProgress();
    this.assetLienService.updateAssetLienFlag(this.asset.assetId, lienFlag)
      .subscribe(response => {
        if (response && response.error) {
          this.dialogService.showMessage('Error updating asset lien flag');
        }
        this.dialogService.hideProgress();
      });
  }

  public canModifyLien(): boolean {
    return !(this.asset.equipId && this.isTm) && this.assetControlGroup && !this.assetControlGroup.isSalesHubNonMarsContract;
  }
}
